import React, { useEffect, useRef, useState } from "react";
import classNames from "classnames";
import { AutoComplete, Input, Select } from "@gw/web-basic-components";
import { useThrottle } from "@gw/hooks";
import { useBusinessConfig } from "..";
import type { ISearchProps } from "./dto";
import styles from "./index.module.less";

const { Search } = Input;
/**
 * 搜索框业务组件
 * @deprecated 1.x版本组件，不再维护，请尽快迁移至本地项目
 */
const GWSearch = (props: ISearchProps) => {
  const { apis, useRequest } = useBusinessConfig();

  const autoCompleterEle = useRef<any>(null);
  const [inputValue, setInputValue] = useState("");
  const [typeOptions, setTypeOptions] = useState([]);
  const [typeObj, setTypeObj] = useState({});
  const [selectedOption, setSelectedOption] = useState(
    props.typeOptions?.[0].value
  );

  const [alternatives, setAlternatives] = useState([]);

  const [, fetchOptions] = useRequest(
    apis[props.apiName][props?.fetchName || "alternatives"]
  );

  const renderLabel = (item: string, searchValue) => {
    const index = item.indexOf(searchValue);
    const beforeStr = item.substring(0, index);
    const afterStr = item.substring(index + searchValue.length);
    const label =
      index > -1 ? (
        <span>
          {beforeStr}
          <span className={styles.matchValue}>{searchValue}</span>
          {afterStr}
        </span>
      ) : (
        <span>{item}</span>
      );
    return label;
  };

  /**
   * 选出某一个备选项，点击搜索的回调
   * @param value
   */
  const onSearch = (value: string) => {
    console.log("onSearch", value);
    props.onInputChange(selectedOption, value.trim());
  };

  // 选出类型的回调
  const onTypeChange = (type: string) => {
    console.log(type);

    setSelectedOption(type);
    setInputValue("");
    onSearch("");
    autoCompleterEle.current?.blur();
  };

  // search alternatives on input
  const handleSearchAlternatives = useThrottle(
    (newInputValue: string) => {
      fetchOptions({
        type: selectedOption,
        query: newInputValue,
        ...(props.extraParam && props.extraParam),
      }).then((res: IResDataList<any>) => {
        const options = res.dataList.map((option, idx) => {
          let { value } = option;

          if (typeof value === "object") {
            value = value[selectedOption];
          }
          const label = (
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              {renderLabel(value, newInputValue)}
            </div>
          );
          const key = value + idx;

          return { value, key, label };
        });
        setAlternatives(options);
      });
    },
    500,
    []
  );

  const onFocus = (event: any) => {
    handleSearchAlternatives(event.target.value);
  };

  const onChange = (value: string) => {
    setInputValue(value);
  };

  useEffect(() => {
    setTypeOptions(props.typeOptions);
    const newTypeObj = { ...typeObj };
    props.typeOptions?.forEach((m) => {
      newTypeObj[m.value] = m.label;
    });
    setTypeObj(newTypeObj);
    // if (
    //   props.typeOptions &&
    //   props.typeOptions[0] &&
    //   props.typeOptions[0].value
    // ) {
    //   setSelectedOption(props.typeOptions[0].value);
    // }
  }, [props.typeOptions]);

  useEffect(() => {
    if (props.clear) {
      setInputValue("");
    }
  }, [props.clear]);

  return (
    <div
      style={props.style}
      className={classNames(styles.searchContainer, props.className)}
    >
      <Select
        value={selectedOption}
        placeholder="请选择"
        onChange={onTypeChange}
        options={typeOptions}
        showArrow={true}
        style={{ fontSize: 14 }}
        size="small"
      />
      <AutoComplete
        ref={autoCompleterEle}
        value={inputValue}
        onChange={onChange}
        options={alternatives}
        onSelect={onSearch}
        onSearch={handleSearchAlternatives}
        onFocus={onFocus}
      >
        <Search
          placeholder={
            props?.placeholder || `请输入${typeObj[selectedOption] || "关键字"}`
          }
          enterButton="搜索"
          onSearch={onSearch}
        />
      </AutoComplete>
    </div>
  );
};
export default GWSearch;
